/** Enhance server-rendered snapshots with native, non-modal popovers. */
(function initializeTpgContextPreview(window, document) {
  'use strict';

  if (window.TPGContextPreview) {
    window.TPGContextPreview.init();
    return;
  }

  const ROOT_SELECTOR = '[data-tpg-context-preview]';
  const FALLBACK_OPEN_SELECTOR = '[data-tpg-preview-fallback][open]';

  /** Close an older browser's disclosure without disturbing outside focus. */
  function closeFallback(details, restoreFocus) {
    details.open = false;
    if (restoreFocus) {
      details.querySelector('summary').focus();
    }
  }

  /** Enhance once per mounted component; untouched HTML works without JS. */
  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.tpgPreviewReady) {
        return;
      }
      const trigger = root.querySelector('[data-tpg-preview-trigger]');
      const details = root.querySelector('[data-tpg-preview-fallback]');
      const panel = root.querySelector('[data-tpg-preview-panel]');
      const close = root.querySelector('[data-tpg-preview-close]');
      if (!trigger || !details || !panel || !close) {
        return;
      }

      close.hidden = false;
      if (typeof panel.showPopover !== 'function') {
        root.dataset.tpgPreviewReady = 'fallback';
        close.addEventListener('click', () => closeFallback(details, true));
        return;
      }

      // Move only inside the component, never into document.body. The native
      // top layer handles clipping, light dismiss, Escape, and focus order.
      panel.setAttribute('popover', 'auto');
      root.appendChild(panel);
      details.hidden = true;
      trigger.hidden = false;
      root.dataset.tpgPreviewReady = 'native';
      panel.addEventListener('beforetoggle', (event) => {
        trigger.setAttribute('aria-expanded', String(event.newState === 'open'));
      });
    });
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll(FALLBACK_OPEN_SELECTOR).forEach((details) => {
      if (!details.contains(event.target)) {
        closeFallback(details, false);
      }
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }
    const openDetails = document.querySelectorAll(FALLBACK_OPEN_SELECTOR);
    if (openDetails.length) {
      event.preventDefault();
      openDetails.forEach((details) => closeFallback(details, true));
    }
  });

  window.TPGContextPreview = Object.freeze({ init });
  window.addEventListener('tpg:shell-route-settled', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})(window, document);
